import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useMemo, useReducer } from 'react';
import Dialog from './Dialog';
const DialogStateDefault = {
    state: {},
    dispatch: null
};
export const DialogContext = createContext(DialogStateDefault);
export var DialogActions;
(function (DialogActions) {
    DialogActions[DialogActions["SHOW_MODAL"] = 0] = "SHOW_MODAL";
    DialogActions[DialogActions["HIDE_MODAL"] = 1] = "HIDE_MODAL";
    DialogActions[DialogActions["TOGGLE_CONFIRM_ENABLED"] = 2] = "TOGGLE_CONFIRM_ENABLED";
})(DialogActions || (DialogActions = {}));
const reducer = (state, action) => {
    switch (action.type) {
        case DialogActions.SHOW_MODAL:
            return {
                ...action.modalProps,
                show: true
            };
        case DialogActions.HIDE_MODAL:
            return {
                ...state,
                show: false
            };
        case DialogActions.TOGGLE_CONFIRM_ENABLED:
            return {
                ...state,
                disableConfirm: !state.disableConfirm
            };
        default:
            return {
                ...state
            };
    }
};
function DialogProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, null);
    const value = useMemo(() => ({ state, dispatch }), [state]);
    return (_jsxs(DialogContext.Provider, { value: value, children: [children, state && _jsx(Dialog, { ...state })] }));
}
export default DialogProvider;
